export default __webpack_public_path__ + "static/media/053-credit-cards.04c89f32.svg";